import Proxy from './Proxy';

class MainInfoProxy extends Proxy {

  constructor(parameters = {}) {
    super('api/settings/info', parameters);
  }

  /**
   * 권한별 메인 소식 리스트
   * @returns {Promise}
   */
  getMainNotice() {
    return this.submit('get', `/${this.endpoint}/notices`);
  }


  getMainContactInfo() {
    return this.submit('get', `/${this.endpoint}/main-info`);
  }

  saveMainContactInfo( item ) {
    return this.submit('post', `/${this.endpoint}/main-info/save-contact`, item );
  } 

}

export default MainInfoProxy;
